<template>
    <v-popover offset="0" :open="isOpen" trigger="click" :autoHide="true" v-on:auto-hide="close">

        <span class="tooltip-target" data-testid="client-banner-insurance" @click="open">
            <span class="badge badge-secondary badge_health_insurance" v-if="client.health_insurance" :class="'_'+client.health_insurance.code" :title="client.health_insurance.name">{{ client.health_insurance.code === '---' ? client.health_insurance.shortcut : client.health_insurance.code}}
                <i v-if="client.health_insurance.type === '2'" class="fa fa-file-text-o" aria-hidden="true"></i>
                <i v-if="client.health_insurance.type === '3'" class="fa fa-plane" aria-hidden="true"></i>
                <i v-if="client.health_insurance.type === '4'" class="fa fa-globe" aria-hidden="true"></i>
            </span>
            <span class="tooltip-target badge pointer badge-warning badge_health_insurance" role="button" v-else=""><i class="fa fa-warning" aria-hidden="true"></i> chybí zdrav. pojišťovna</span>
        </span>
        <template slot="popover">
            <div class="container tooltip_container tooltip_1_5_col" v-if="!insuranceCompaniesPending">
                <div class="row tooltip_header">
                    <div class="col-sm-2 text-left">
                        <button class="btn btn-sm btn-outline-secondary" data-testid="client-insurance-edit" @click="edit" v-if="editMode === false && client.health_insurance"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> změnit</button>
                        <button class="btn btn-sm btn-outline-secondary" data-testid="client-insurance-back" @click="view" v-else-if="editMode === true"><i class="fa fa-arrow-left" aria-hidden="true"></i> zpět</button>
                    </div>
                    <div class="col-sm-8" v-if="editMode === true">Úprava zdravotního pojištění</div>
                    <div class="col-sm-8" v-else-if="!client.health_insurance">Výběr zdravotního pojištění</div>
                    <div class="col-sm-8" v-else="">Detail zdravotního pojištění</div>
                    <div class="col-sm-2"></div>
                </div>

                <div class="row" v-if="editMode === true">
                    <table class="table">
                        <thead>
                        <tr class="row m-0">
                            <th class="col-sm-2">pojišťovna</th>
                            <th class="col-sm-3">druh</th>
                            <th class="col-sm-3 text-right">platné od</th>
                            <th class="col-sm-3 text-right">platné do</th>
                            <th class="col-sm-1"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="row m-0 text-left" data-testid="client-insurance-row" v-for="ci in clientInsurances" :class="ci.is_valid ? 'font-weight-bold' : ''">
                            <td class="col-sm-2">{{ ci.insurance_company.shortcut }}</td>
                            <td class="col-sm-3">{{ ci.type }} - {{ ci.type | insuranceTypeIntToName }}</td>
                            <td class="col-sm-3 text-right">{{ ci.valid_from }}</td>
                            <td class="col-sm-3 text-right">{{ ci.valid_to }}</td>
                            <td class="col-sm-1 text-right">
                                <template v-if="ci.valid_to === null">
                                    <button v-if="!deleteInsurancePending" data-testid="client-insurance-delete" @click="deleteInsurance(ci.id)" class="btn btn-sm btn-outline-danger"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                                    <button class="btn btn-sm btn-outline-danger disabled" v-else disabled="disabled"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="col-sm-12">
                        <form @submit.prevent="postInsurance(client.id)">
                            <div class="form-group">
                                <label for="insuranceCompanySelect">Zdravotní pojišťovna</label>
                                <select class="form-control" data-testid="client-insurance-company" v-model="insurance.insurance_company" id="insuranceCompanySelect">
                                    <option v-for="ic in insuranceCompanies" v-bind:value="ic.code">{{ ic.code }} - {{ ic.shortcut }} - {{ ic.name }}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="insuranceValidFrom" class="ml-sm-2 mr-sm-2">od data</label>
                                <select class="form-control" data-testid="client-insurance-valid-from" v-model="insurance.valid_from" id="insuranceValidFrom">
                                    <option v-for="pd in possibleDates" v-bind:value="pd">{{ pd }}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="insuranceType" class="ml-sm-2 mr-sm-2">druh</label>
                                <select class="form-control" data-testid="client-insurance-type" v-model="insurance.type" id="insuranceType">
                                    <option v-for="n in 4" v-bind:value="n">{{ n }} - {{ n | insuranceTypeIntToName }}</option>
                                </select>
                            </div>
                            <button v-if="!insurancePending" data-testid="client-insurance-save" type="submit" class="btn btn-success btn-sm">Uložit</button>
                            <button class="btn btn-primary btn-sm disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                        </form>
                    </div>
                </div>
                <div class="row" v-else-if="!client.health_insurance">
                    <div class="col-sm-12">
                        <form @submit.prevent="postInsurance(client.id)">
                            <div class="form-group">
                                <label for="insuranceCompanySelect">Zdravotní pojišťovna</label>
                                <select class="form-control" data-testid="client-insurance-company" v-model="insurance.insurance_company" id="insuranceCompanySelect">
                                    <option v-for="ic in insuranceCompanies" v-bind:value="ic.code">{{ ic.code }} - {{ ic.shortcut }} - {{ ic.name }}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="insuranceType" class="ml-sm-2 mr-sm-2">druh</label>
                                <select class="form-control" data-testid="client-insurance-type" v-model="insurance.type" id="insuranceType">
                                    <option v-for="n in 4" v-bind:value="n">{{ n }} - {{ n | insuranceTypeIntToName }}</option>
                                </select>
                            </div>
                            <button v-if="!insurancePending" data-testid="client-insurance-save" type="submit" class="btn btn-success btn-sm">Uložit</button>
                            <button class="btn btn-primary btn-sm disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                        </form>
                    </div>
                </div>
                <div class="" v-else="">
                    <div class="d-flex justify-content-center">
                        <div class="">
                            <span class="badge badge-secondary badge_health_insurance badge_large" :class="'_'+client.health_insurance.code" :title="client.health_insurance.name">{{ client.health_insurance.shortcut }}</span>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center" data-testid="client-insurance-detail">
                        <div class="p-2">
                            <span class="h5">{{ client.health_insurance.name }}</span><br>
                            <span class="h6">({{ client.health_insurance.type | insuranceTypeIntToName }})</span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </v-popover>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        insuranceCompaniesPending: true,
        editMode: false,
        insuranceDone: false,
        isOpen: false,
        insurance: {
          insurance_company: null,
          type: 1
        },
        clientInsurances: false,
        insurancePending: false,
        birthDateCalculated: false,
        possibleDates: [],
        // DELETE
        deleteInsurancePending: false,
        deleteInsuranceDone: false,
        deleteInsuranceError: false
      }
    },
    mixins: [apiMixin],
    props: ['client', 'clientHeader'],
    methods: {
      open () {
        this.isOpen = true
        this.editMode = false
      },
      close () {
        this.isOpen = false
      },
      edit () {
        this.editMode = true
      },
      view () {
        this.editMode = false
      }
    },
    watch: {
      isOpen (val) {
        if (val === true) {
          let startDate = this.$moment().subtract(1, 'year').dayOfYear(1)
          this.possibleDates = []
          for (let i = 0; i < 6; i++) {
            this.possibleDates.push(startDate.add(6, 'months').format('L'))
          }
          this.getInsuranceCompanies()
          if (this.client.health_insurance) {
            this.getClientInsurances(this.client.id)
          }
        } else {
          this.insuranceCompaniesPending = true
        }
      },
      insuranceDone (val) {
        if (val === true) {
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.insuranceDone = false
          this.close()
        }
      },
      deleteInsuranceDone (val) {
        if (val === true) {
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.deleteInsuranceDone = false
          this.close()
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .badge_large {
        font-size: xx-large;
    }
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .input-group.input-group-unstyled input.form-control {
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }
    .input-group-unstyled .input-group-addon {
        border-radius: 4px;
        border: 0px;
        background-color: transparent;
    }
    .row_description {
    }
    .row_description > td {
        padding-bottom: 1px;
        border: none;
        font-size: smaller;
    }
    .row_data {
    }
    .row_data > td {
        padding-top: 0px;
        font-weight: bold;
        font-size: large;
        border: none;
    }

    .width_fix {
        width: 100%;
    }
    .label_like {
        max-width: 100%;
        /*font-weight: bold;*/
    }
    .main_attribute {
        max-width: 100%;
        font-size: x-large;
        font-weight: bold;
    }

    .custom_panel_heading {
        border-bottom: none;
        padding-bottom: 0;
        background-color: #b5e3cf;
    }

    .custom_panel_heading .nav-tabs {
        border-bottom: none;
    }

    .custom_panel_heading .nav-tabs > li > a {
        background-color: #fff;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(odd) {
        margin-right: 0;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(even) {
        margin-left: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/Client/components/ClientInsurance.vue?10c7f4bd